/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-16 16:23:10
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 首营企业管理

// 新增
export function getAddCompanyRecord(supplierId: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellcompanyrecord/createFirstSellCompanyRecord`,
    method: 'POST',
    params: {
      supplierId,
    },
  }
}

// 列表
export interface BusinessManagementListParams {
  startTime?: any
  endTime?: any
  current?: any
  size?: any
  acceptStatus?: any
  companyName?: any
}

export function getBusinessManagementList(
  params: BusinessManagementListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellcompanyrecord/list`,
    method: 'GET',
    params,
  }
}

// 详情
export function getBusinessManagementDetail(fscrId: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellcompanyrecord/detail`,
    method: 'GET',
    params: {
      fscrId,
    },
  }
}

// 导出
export function getBusinessListExport(
  params: BusinessManagementListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellcompanyrecord/list/exportexcel`,
    method: 'POST',
    responseType: 'blob',
    params,
  }
}

// 审批
export function getBusinessAccept(body: AcceptParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellcompanyrecord/accept`,
    method: 'POST',
    body,
  }
}

// 保存编辑
export interface SubmitParams {
  blxwFlag?: any
  gspfyjFlag?: any
  gwdwFlag?: any
  khhFlag?: any
  id?: any
  other?: any
  scfyjFlag?: any
  sdkcFlag?: any
  sdkcOpinion?: any
  sqsFlag?: any
  supplierGoods?: any
  supplierRange?: any
  yyzzfyjFlag?: any
  yzFlag?: any
  zfwzFlag?: any
  zlbzxyFlag?: any
  zlwtFlag?: any
}

export function getFirstsellcompanyrecordBaseSubmit(
  body: SubmitParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellcompanyrecord/baseSubmit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getFirstsellcompanyrecordBaseDelete(recordId: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellcompanyrecord/remove`,
    method: 'POST',
    params: {
      recordId,
    },
  }
}

// 首营品种

// 新增
export function getAddFirstBussiness(tenantMaterialsCatalogId: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellrecord/createFirstSellGoodsRecord`,
    method: 'POST',
    params: {
      tenantMaterialsCatalogId,
    },
  }
}

// 列表
export interface varietyManagementListParams {
  startTime?: any
  endTime?: any
  current?: any
  size?: any
  acceptStatus?: any
  goodsName?: any
}

export function getVarietyManagementList(
  params: varietyManagementListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellrecord/list`,
    method: 'GET',
    params,
  }
}

// 详情
export function getDetail(fsrid: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellrecord/detail`,
    method: 'GET',
    params: {
      fsrid,
    },
  }
}

// 审批
export interface AcceptParams {
  acceptFlag?: any
  acceptType?: any
  acceptUser?: any
  id?: any
  opinion?: any
}

export function getAccept(body: AcceptParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellrecord/accept`,
    method: 'POST',
    body,
  }
}

// 保存
export interface BaseSubmitParams {
  contactName?: any
  contactPhone?: any
  createUser?: any
  deadline?: any
  id?: any
  indication?: any
  qualityCondition?: any
  qualityStandard?: any
  remark?: any
}

export function getFirstsellrecordBaseSubmit(body: BaseSubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellrecord/baseSubmit`,
    method: 'POST',
    body,
  }
}

// 导出
export function getVarietyManagementListExport(
  params: varietyManagementListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellrecord/list/exportexcel`,
    method: 'POST',
    responseType: 'blob',
    params,
  }
}

// 删除
export function getVarietyManagementDelete(recordId: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/firstsellrecord/remove`,
    method: 'POST',
    params: {
      recordId,
    },
  }
}
